import React from "react";

interface IconProps {
  size?: number;
  color?: string;
  className?: string;
}

export default function LocalOnlyIcon({ size = 20, color = "white", className }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M9.56953 18.7873C9.69036 18.8998 9.84453 18.9582 9.9987 18.9582C10.1529 18.9582 10.307 18.8998 10.4279 18.7873C10.707 18.5207 17.2904 12.2373 17.2904 8.33317C17.2904 4.31234 14.0195 1.0415 9.9987 1.0415C5.97786 1.0415 2.70703 4.31234 2.70703 8.33317C2.70703 12.2373 9.29036 18.5207 9.56953 18.7873ZM9.9987 2.2915C13.332 2.2915 16.0404 4.99984 16.0404 8.33317C16.0404 10.929 12.0154 15.4582 9.9987 17.4623C7.98203 15.4582 3.95703 10.9332 3.95703 8.33317C3.95703 4.99984 6.66536 2.2915 9.9987 2.2915Z" fill={color}/>
      <path d="M13.125 8.33301C13.125 6.60801 11.725 5.20801 10 5.20801C8.275 5.20801 6.875 6.60801 6.875 8.33301C6.875 10.058 8.275 11.458 10 11.458C11.725 11.458 13.125 10.058 13.125 8.33301ZM8.125 8.33301C8.125 7.29967 8.96667 6.45801 10 6.45801C11.0333 6.45801 11.875 7.29967 11.875 8.33301C11.875 9.36634 11.0333 10.208 10 10.208C8.96667 10.208 8.125 9.36634 8.125 8.33301Z" fill={color}/>
    </svg>
  );
}
